"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.button = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

const buttonVariationStyles = theme => ({
  transparent: (0, _stylitas.css)`
    background-color: transparent;
    border: 1px solid ${theme.colorNeutral20};

    &:hover {
      background-color: ${theme.colorButtonPrimaryLight};
    }
  `,
  primary: (0, _stylitas.css)`
    border: none;
    background-color: ${theme.colorButtonPrimaryLight};
    font-weight: 500;
    transition: box-shadow 0.3s;
  `
});

const buttonVariantionSizes = theme => ({
  small: (0, _stylitas.css)`
    padding: 6px 12px;
    border-radius: 8px;
    ${_styleUtilities.typography.sm(theme)}
  `,
  medium: (0, _stylitas.css)`
    padding: 12px 20px;
    border-radius: 10px;
    ${_styleUtilities.typography.sm(theme)}
  `,
  large: (0, _stylitas.css)`
    padding: 18px 20px;
    border-radius: 16px;
    ${_styleUtilities.typography.md(theme)}
  `
});

const buttonExtraStyles = () => ({
  hasOnlyIcon: (0, _stylitas.css)`
    border-radius: 50%;
    width: 64px;
    height: 64px;
    padding: 0px;
  `
});

const buttonVariationHoverStyles = ({
  theme
}) => ({
  transparent: (0, _stylitas.css)`
    background-color: ${theme.colorButtonPrimaryLight};
    border-color: ${theme.colorButtonPrimaryLight};
  `,
  primary: (0, _stylitas.css)`
    box-shadow: 0px 16px 8px -12px rgba(0, 0, 0, 0.12),
      0px 16px 12px -8px rgba(0, 0, 0, 0.16);
  `
});

const button = ({
  theme,
  hasOnlyIcon,
  variant,
  alignment,
  size
}) => (0, _stylitas.css)`
    width: 100%;
    text-decoration: none;
    cursor: pointer;
    position: relative;

    display: flex;
    align-items: center;

    justify-content: ${alignment};
    color: ${theme.colorNeutral90};

    ${buttonVariantionSizes(theme)[size]}
    ${buttonVariationStyles(theme)[variant]}
    ${hasOnlyIcon && buttonExtraStyles().hasOnlyIcon}

    &:hover {
      ${buttonVariationHoverStyles({
  theme
})[variant]}
    }

    &:active {
      &::before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${theme.colorNeutral90};
        opacity: 0.05;
      }
    }

  `;

exports.button = button;